export const email = async (args: string[]): Promise<string> => {
  window.open('mailto:andythsu.98@gmail.com');

  return 'Opening mailto:andythsu.98@gmail.com...';
};
